import { camelToSnakeKeys, formatDateToString } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '@convenia/common-organisms/SystemFields/content/consts'

export const mapForeign = (data = {}) => ({
  ...data,
  arrivalDate: formatDateToString(data?.arrivalDate),
  naturalizationDate: formatDateToString(data?.naturalizationDate),
  marriedToBrazilian: !!data?.marriedToBrazilian,
  hasBrazilianOffspring: !!data?.hasBrazilianOffspring,
  residenceTimeId: data?.residenceTime?.id,
  entryConditionId: data?.entryCondition?.id,
  visaId: data?.visa?.id,
  addressDescription: data?.addressDescription?.id || '',
  countryId: data?.country?.id,
})

export const mapForeignInput = ({ schema, data } = {}) => ({
  ...camelToSnakeKeys({
    id: data?.id,
    visaId: data?.visaId,
    countryId: data?.countryId,
    arrivalDate: formatDateToString(data?.arrivalDate),
    naturalizationDate: formatDateToString(data?.naturalizationDate),
    marriedToBrazilian: data?.marriedToBrazilian,
    hasBrazilianOffspring: data?.hasBrazilianOffspring,
    livesInBrazil: data?.livesInBrazil,
    residenceTimeId: data?.residenceTimeId,
    entryConditionId: data?.entryConditionId,
    zipCodeForeign: data?.zipCodeForeign,
    addressDescriptionId: Number(data?.addressDescription) || null,
    foreignAddress: data?.foreignAddress,
    number: data?.number,
    complement: data?.complement,
    district: data?.district,
    city: data?.city,
  }),
  custom_fields: mapCustomFieldValues({
    data,
    schema,
    sectionId: PERSONAL_AREA.FOREIGN,
  })
})
